/**
 * ProtectedRoute.jsx — The React Bouncer
 *
 * Gate logic:
 *   1. Still loading auth state  → hold (spinner)
 *   2. Not logged in             → /purgatory
 *   3. Not in authorized_users   → /purgatory
 *   4. Authorized                → render route
 *
 * Usage in App.jsx:
 *   <Route element={<ProtectedRoute />}>
 *     <Route path="/dashboard" element={<DashboardHome />} />
 *     ...
 *   </Route>
 */

import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingSpinner from '../shared/LoadingSpinner';

export default function ProtectedRoute() {
  const { currentUser, isAuthorized, loading } = useAuth();

  // Still resolving auth state — hold the door
  if (loading) {
    return <LoadingSpinner />;
  }

  // Not authorized — bounce to purgatory
  if (!currentUser || !isAuthorized) {
    return <Navigate to="/purgatory" replace />;
  }

  // Authorized — let them through
  return <Outlet />;
}
